module.exports = __webpack_public_path__ + "img/eacf96d.png";